import { fromJS } from 'immutable'
import {
  COMPENSATE_REQUEST_PREVIEW_REQUEST,
  COMPENSATE_REQUEST_PREVIEW_SUCCESS,
  COMPENSATE_REQUEST_PREVIEW_FAILURE,
  COMPENSATE_REQUEST_PREVIEW_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPENSATE_REQUEST_PREVIEW_REQUEST:
      return state
        .set('isFetching', false)
    case COMPENSATE_REQUEST_PREVIEW_SUCCESS:
      return state
        .set('createdCompensatePreview', fromJS(action.payload.createdCompensate))
        .set('status', 200)
        .set('isFetching', false)
        // .set('message', 'Created Successfully.')
    case COMPENSATE_REQUEST_PREVIEW_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('createdCompensatePreview', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case COMPENSATE_REQUEST_PREVIEW_RESET:
      return state
        .delete('createdCompensatePreview')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/compensate-request/compensate-request-preview-reducer.js